import React, { useEffect, useState } from "react";
import hrApi from "./hrApi";

// Start an SMS from a saved SMS template; {{fields}} are filled in per person when sent.
export function SmsTemplatePicker({ onPick }) {
  const [tpls, setTpls] = useState([]);
  useEffect(() => {
    hrApi.get("/msg-templates").then((r) => setTpls(r.data.filter((t) => t.channel === "sms" && t.active !== false && !t.deleted))).catch(() => {});
  }, []);
  if (!tpls.length) return null;
  return (
    <div className="space-y-1">
      <select data-testid="sms-template-pick" defaultValue="" onChange={(e) => { const t = tpls.find((x) => x.id === e.target.value); if (t) onPick(t.body); e.target.value = ""; }}
        className="w-full h-10 rounded-xl border border-slate-200 bg-white px-3 text-sm">
        <option value="">Start from a saved SMS template…</option>
        {tpls.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
      </select>
      <p className="text-[11px] text-slate-400">Fields like {"{{first_name}}"} are filled in for each person when sent.</p>
    </div>
  );
}
